import Widget from 'models/dashboard/widget'

Widget.TagTopSourcesWidget = Widget.extend({
  tagIds: function () {
    return this.get('tag_ids');
  }
});

export default Widget.TagTopSourcesWidget;

